import type { AdminPathKey } from "metabase/redux/store";
import type { User } from "metabase-types/api";

const canAccessMonitoringItems = (user?: User) =>
  user?.permissions?.can_access_monitoring ?? false;

const canAccessSettings = (user?: User) =>
  user?.permissions?.can_access_setting ?? false;

export const monitoringPermissionAllowedPathGetter = (
  user?: User,
): AdminPathKey[] => (canAccessMonitoringItems(user) ? ["help"] : []);

export const settingsPermissionAllowedPathGetter = (
  user?: User,
): AdminPathKey[] => (canAccessSettings(user) ? ["settings"] : []);
